import { buttonStyle , commonStyles } from "src/Library/CommonStyles";
import { tokens } from 'src/design-system';

export const SendBulkInquiryStyles = (theme: any) => ({
    drawer: {
      '& .ant-drawer-header': {
        borderBottom: '1px solid #CCCCCC',
      },
      '& .ant-drawer-body': {
        padding: '20px',
      },
      '& .ant-drawer-content-wrapper': {
        minWidth: '500px',
      },
      '& .ant-drawer-title': {
        fontWeight: 500,
        fontSize: `${tokens.fontSize.h3}px`,
      },
    },
    modalHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    modalTitle: {
      fontWeight: tokens.fontWeight.semibold,
      fontSize: `${tokens.fontSize.h1}px`,
      marginLeft: `${tokens.spacing.md}px`,
    },
    closeIcon: {
      cursor: 'pointer',
      fontSize: `${tokens.fontSize.h1}px`,
    },
    submitButton: {
      ...buttonStyle(tokens.colors.bgWhite, tokens.colors.primaryDark, `1px solid ${tokens.colors.primaryDark}`),
      padding: '0px 10px',
      borderRadius: `${tokens.radius.md}px`,
      marginLeft: '28px',
    },
    submitButtonDisabled: {
      ...buttonStyle(tokens.colors.bgWhite, '#CCCCCC', '1px solid #CCCCCC'),
      padding: '0px 10px',
      borderRadius: `${tokens.radius.md}px`,
      marginLeft: '28px',
      cursor: 'not-allowed',
    },
    selectedFFsPanel: {
      ...commonStyles(theme).justifySpaceBetween,
      fontWeight: tokens.fontWeight.semibold,
      width: '230px',
      color: tokens.colors.text,
    },
    multiselect: {
      '& .ant-select': {
        color: 'black',
      },
      '& .ant-select-selected-icon': {
        color: 'blue ',
      },
      '& .ant-select-selection': {
        color: 'green',
        fontSize: `${tokens.fontSize.small}px`,
      },
      '& .ant-checkbox-disabled .ant-checkbox-inner': {
        backgroundColor: '#b0e0aa',
      },
    },
    optionsDiv: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      marginLeft: tokens.spacing.ms,
    },
    sentBidStyle: {
      color: '#b0e0aa',
      fontSize: `${tokens.fontSize.small}px`,
    },
    groupType: {
      backgroundColor: '#EDE3FC',
      border: '1px solid #A082CE',
      padding: '0px 4px',
      marginLeft: '5px',
      fontSize: `${tokens.fontSize.caption}px`,
      borderRadius: `${tokens.radius.sm}px`,
    },
    ffType: {
      backgroundColor: '#FFE7D5',
      border: '1px solid #FFC59A',
      padding: '0px 4px',
      marginLeft: '5px',
      fontSize: `${tokens.fontSize.caption}px`,
      borderRadius: `${tokens.radius.sm}px`,
    },
    ffList: {
      ...commonStyles(theme).fixedScrollbar,
      maxHeight: '120px',
      overflow: 'auto',
      marginTop: `${tokens.spacing.sm}px`,
    },
    FfsPanel: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      margin: '10px 0px 20px 0px',
    },
    selectedRowContainer: {
      padding: `${tokens.spacing.xs}px 0`,
      borderBottom: `1px solid ${tokens.colors.border}`,
    },
    groupVendorsList: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: `${tokens.spacing.xs}px`,
      padding: `${tokens.spacing.xs}px ${tokens.spacing.xs}px ${tokens.spacing.xs}px ${tokens.spacing.ms}px`,
    },
    groupVendorTag: {
      backgroundColor: tokens.colors.bgSubtle,
      color: tokens.colors.textSecondary,
      padding: `${tokens.spacing.xxs}px ${tokens.spacing.sm}px`,
      fontSize: `${tokens.fontSize.caption}px`,
      borderRadius: `${tokens.radius.sm}px`,
      border: `1px solid ${tokens.colors.border}`,
    },
    groupEmpty: {
      padding: `${tokens.spacing.xxs}px ${tokens.spacing.ms}px`,
      fontSize: `${tokens.fontSize.caption}px`,
      color: tokens.colors.textTertiary,
      fontStyle: 'italic',
    },
  })
